import { FieldLabel } from '../_shared'
import {
  BambooProfileBody,
  CreateIssueButtonBody,
  CustomHtmlBody,
  FinRenewalButtonBody,
  HeadingBody,
  JqlTableBody,
  ProgressChecklistBody,
  SlackDmButtonBody,
} from '../config-forms'
import type { Block } from '../config-types'

import { FieldRowList } from './FieldRow'

/** Editor for the currently selected block, keyed by its `type`. */
export function BlockInspector({
  block,
  onChange,
}: {
  block: Block
  onChange: (b: Block) => void
}) {
  switch (block.type) {
    case 'heading':
      return <HeadingBody block={block} onChange={onChange} />
    case 'divider':
      return (
        <p className="text-[12.5px] text-text-2">
          No settings — a divider draws a horizontal rule between blocks.
        </p>
      )
    case 'issue_fields':
      return <FieldRowList block={block} onChange={onChange} />
    case 'jql_table':
      return <JqlTableBody block={block} onChange={onChange} />
    case 'progress_checklist':
      return (
        <div className="space-y-2">
          <FieldLabel>steps</FieldLabel>
          <ProgressChecklistBody block={block} onChange={onChange} />
        </div>
      )
    case 'custom_html':
      return <CustomHtmlBody block={block} onChange={onChange} />
    case 'slack_dm_button':
      return <SlackDmButtonBody block={block} onChange={onChange} />
    case 'fin_renewal_button':
      return <FinRenewalButtonBody block={block} onChange={onChange} />
    case 'create_issue_button':
      return <CreateIssueButtonBody block={block} onChange={onChange} />
    case 'bamboo_profile':
      return <BambooProfileBody block={block} onChange={onChange} />
    default:
      return null
  }
}
